/** Env var to determine if using a production environment
 *  true when in a prod environment
 */
export const isProd = process.env.ENVIRONMENT === 'production';

/**
 * Locale used for displaying names in toLocaleDateString formatting.
 * Ensures consistent formatting (e.g., "Jan", "Mon") regardless of browser locale.
 * Note: Week start day calculation still respects browser locale.
 */
export const DISPLAY_DATE_LOCALE = 'en-US';

export const TERMS_OF_SERVICES_URL = 'http://cribl.io/legal/terms';

export const COOKIE_NAMES = {
  SELECTED_TENANT_ID: 'selectedTenantId',
  AUTH0_ORG_ID: 'auth0OrgId',
  AUTH0_LOGOUT: 'cribl_auth0_logout',
  CRIBL_DOCS: 'criblDocs',
  SELECTED_ORG: 'selectedOrg',
} as const;

export const QUERY_PARAMS = {
  SANDBOX: {
    ID: 'sandboxID',
    CALLBACK_URL: 'sandboxCallbackUrl',
  },
} as const;

export const STORAGE_PARAMS = {
  SANDBOX: {
    INFO: 'sandbox_info',
  },
} as const;

export const CALLBACK_ERRORS = {
  GENERAL: {
    key: 'GENERAL',
    text: 'The operation you tried is not valid',
    description: 'Please try again!',
  },
  ROLE: {
    key: 'ROLE',
    text: 'Something Went Wrong',
    description: 'Your role is not configured correctly.',
  },
  ACCESS_DENIED: {
    key: 'ACCESS_DENIED',
    text: 'Unable to log in',
    description: 'Please try again later or contact support for assistance.',
  },
  ACCESS_DENIED_CIDR: {
    key: 'ACCESS_DENIED_CIDR',
    text: 'Unable to log in',
    description: 'This resource is only accessible from approved network locations.',
  },
  RATE_LIMITED: {
    key: 'RATE_LIMITED',
    text: 'Too many login attempts',
    description: 'Please wait a moment and try again.',
  },
  ACCESS_DENIED_SAML_EMAIL: {
    key: 'ACCESS_DENIED_SAML_EMAIL',
    text: 'Email address required',
    description:
      'Please contact your administrator to ensure the email attribute is properly configured in your Identity Provider.',
  },
  ACCESS_DENIED_SAML_EMAIL_INVALID: {
    key: 'ACCESS_DENIED_SAML_EMAIL_INVALID',
    text: 'Invalid email address',
    description: 'Please contact your administrator to verify the email attribute mapping in your Identity Provider.',
  },
  ACCESS_DENIED_SAML_IDENTITY: {
    key: 'ACCESS_DENIED_SAML_IDENTITY',
    text: 'SAML identity required',
    description: 'Please contact your administrator to resolve this authentication issue.',
  },
  ACCESS_DENIED_MUST_SIGNUP: {
    key: 'ACCESS_DENIED_MUST_SIGNUP',
    text: 'Account does not exist',
    description: 'Please sign up if you would like to create an account',
  },
  DEFAULT: {
    key: 'DEFAULT',
    text: 'An unexpected error occurred',
    description: 'Please try again later or contact support for assistance.',
  },
} as const;

// Extract just the keys for type safety and easy access
export type CallbackErrorKey = keyof typeof CALLBACK_ERRORS;
